import { useGetPipelineRunStateQuery } from "../../../store/processing/processingSlice";
import Button from "@mui/material/Button";
import { Trans } from "react-i18next";
import { CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { Stop } from "@mui/icons-material";

type Props = {
    onStop: () => void;
    pid: string;
}

export const RunButtonRunning = ({ onStop, pid }: Props): JSX.Element => {
    const { data, error, isLoading } = useGetPipelineRunStateQuery(pid, { pollingInterval: 250 });

    useEffect(() => {
        if (data?.status=="finished") {
            onStop();
        }
    }, [data])

    return (
        <Button variant={'contained'} color={'warning'} startIcon={<Stop />}>
            <Trans>Run</Trans>
        </Button>
    )
}